export default __webpack_public_path__ + "static/media/login-bg.d756ce72.png";